import React, {Component} from 'react';
import { observer, inject, Provider } from "mobx-react";
import { observable, makeObservable, action, reaction, toJS } from "mobx";
import axios from "../../utils/axios";
import commentsStore from "../../stores/commentsStore";
import LazyImg from "../Helpers/LazyImg";
import { NavLink } from "react-router-dom";
import { withRouter } from 'react-router-dom';
import Loading from "../Loading";
import  { Link } from "react-router-dom";
import LastCommentsWithStore from "../Comments/LastCommentsWithStore";
import historyVars from "../../utils/historyVars";
import Paginator from "../Helpers/Paginator/Paginator";
import qs from 'qs';
import HTML from "../Helpers/HTML";

class Spying extends Component {
  list={
    fetching:false,
    inited:false,
    data:{}
  };
  with_readed='0';
  category_id=null;
  page=1;
  selected_cats=[];

  constructor(props) {
    super(props);
    makeObservable(this,{
      list: observable,
      with_readed: observable,
      category_id: observable,
      selected_cats: observable,
      page: observable,
    });

    this._unreactPage=reaction(()=>{ return this.page; },(loc)=>{
      this.reloadElements();
      // this.props.spyingStore.loadComments({ category_id: this.props.category_id, page: this.page });
    });
    this._unreactLocation=reaction(()=>{ return this.props.router.location; },(loc)=>{
      const ob=qs.parse(loc.search, { ignoreQueryPrefix: true });
      this.page=ob.page || 1;
    });
    this._unreactReaded=reaction(()=>{ return this.with_readed },()=>{
      this.loadComments();
    });
    this._unreactCategory=reaction(()=>{ return this.category_id },()=>{
      this.loadComments();
    });

    this._firstTime=true;
  }
  componentWillUnmount() {
    this._unreactPage();
    this._unreactLocation();
    this._unreactReaded();
    this._unreactCategory();
    console.log('unmount!');
  }
  loadComments(force=false) {

  }
  componentDidMount() {
    this.props.spyingStore.loadCounters();
    this.reloadElements();
    // this.checkLoadFilter();
  }
  reloadElements() {
    this.props.spyingStore.loadComments({ category_id: this.props.category_id, page: this.page });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(this.props.category_id !== prevProps.category_id && !this.props.match.params.id) {
      this.reloadElements();
    }
  }

  renderRoot(rootElement, zeroComment) {
    const imgMap={
      51:"property_big_picture",
      56:"property_BIG_PICTURE",
      62:"property_POST_AVATAR",
      74:"property_BIG_PICTURE",
      80:"property_BIG_PICTURE",
      54:"created_by_avatar",
    };
    if(!rootElement) {
      return (
        <div className="ofh rad4-tl rad4-tr bg-w1 solid1-bottom bo-w2">
          <div className="up12 margin">
            <div style={{width:50,height:50}}></div>

            <div className="cell s-auto s-middle">
              <div className="fs11 pbottom2 w5">{this.getCategoryName(zeroComment.category_id)}</div>
              Удалено
            </div>
          </div>
        </div>
      )
    }
    let name=rootElement.name;
    if(!name) {
      if(rootElement.category == 54) {
        name=rootElement.created_by_nick;
      } else {
        name=this.props.translateStore.t.lk.element_type_photo;
      }
    }
    return (
      <div className="ofh rad4-tl rad4-tr bg-w1 solid1-bottom bo-w2">
        <div className="up12 margin">
          {rootElement[imgMap[rootElement.category]]?(
            <div className="cell s-splice">
              <LazyImg src={`/autoresize/50x50xC${rootElement[imgMap[rootElement.category]]}`} className="db mw100" passProps={{ style:{width:50, height:50} }} />
            </div>
          ):(
            <div style={{width:50,height:50}}></div>
          )}
          <div className="cell s-auto s-middle">
            <div className="fs11 pbottom2 w5">{this.getCategoryName(rootElement.category)}</div>
            {rootElement.detail_url?(
              <a href={rootElement.detail_url}><HTML inline={true}>{name}</HTML></a>
            ):(
              <HTML>{name}</HTML>
            )}
          </div>
        </div>

      </div>
    )
  }
  getCategoryName(catId)
  {
    const map={
      62:"Блог пост",
      51:"Фигурка",
      56:"Фото",
      74:"Аниме",
      80:"Персонаж",
      54:"Профиль",
      52:"Новость",
    }
    return map[catId];
  }
  readComment(item, index, commentIndex) {
    console.log("read comment",item._id);
    axios.post(`/api/comments/read`,{ ids:item._id }).then((data)=>{
      if(data.data.answer) {
        this.props.commentsStore.list.data.items[index].items.splice(commentIndex,1);
      }
    });
  }
  readAll(items, index) {
    axios.post(`/api/comments/read`,{ ids: items.map((item)=>{ return item._id }) }).then((data)=>{
      if(data.data.answer) {
        this.props.commentsStore.list.data.items.splice(index,1);
      }
    });
  }
  getPermalink(comment, parent) {
    if(parent && parent.detail_url) {
      return parent.detail_url+`?comment=${comment._id}`;
    }
    return null;
  }
  renderComments() {
    return (
      <div>comments!</div>
    )
  }

  renderFilter() {
    const t=this.props.translateStore.t.lk;
    const checkboxes=[
      {category_id: 0, name: t.type_all },
      {category_id: 62, name: t.type_blog },
      {category_id: 51, name: t.type_figure },
      {category_id: 56, name: t.type_photo },
      {category_id: 74, name: t.type_anime },
      {category_id: 80, name: t.type_character },
      {category_id: 54, name: t.type_profile },
      {category_id: 52, name: t.type_news },
    ];
  }
  categoryToCode(category) {
    const map = {
      51: "figurines",
      56: "photos",
      62: "blog",
      74: "anime",
      80: "characters",
      52: "news",
      54: "profiles",
    };
    return map[category];
  }
  renderRootImage(item) {
    const imgMap={
      51:"property_big_picture",
      56:"property_BIG_PICTURE",
      62:"property_POST_AVATAR",
      74:"property_BIG_PICTURE",
      80:"property_BIG_PICTURE",
      54:"created_by_avatar",
    };
    const imgField=imgMap[item.category];
    if(imgField) {
      return <LazyImg src={`/autoresize/100x100xC${item[imgField]}`} style={{width:50,height:50}} className="db mw100" />
    } else {
      return <div style={{width:50,height:50}}></div>
    }
  }
  renderItemName(rootElement) {
    let name=rootElement.name;
    if(!name) {
      if(rootElement.category == 54) {
        name=rootElement.created_by_nick;
      } else {
        name=this.props.translateStore.t.lk.element_type_photo;
      }
    }
    return name;
  }
  renderDetailUrl(detailUrl) {
    if(this.props.standalone) {
      return <a href={detailUrl} className="mdi mdi-page-next-outline fs24 pr z2"></a>;
    } else {
      return <Link to={detailUrl} className="mdi mdi-page-next-outline fs24 pr z2"></Link>;
    }
  }
  changeFollowState(item, newState) {
    const url=newState?'/api/follow/item':'/api/unfollow/item';
    axios.post(url,{ category_id:item.category, id:item.id }).then(()=>{
      item.unfollowed=!newState;
    });
  }
  renderFollowButton(item) {
    if(item.unfollowed) {
      return <span onClick={()=>{ this.changeFollowState(item, true); }} className="mdi mdi-eye-off fs24 pr z2 w2 sc1-hover pointer"></span>
    } else {
      return <span onClick={()=>{ this.changeFollowState(item, false); }} className="mdi mdi-eye fs24 pr z2 pc1 sc1-hover pointer"></span>
    }
  }
  renderRootElement(item) {
    return (
      <div className="rad4 solid1 bo-w2 bg-w1 pr ofh">
        <div className="up12 margin">
          <div className="cell s-shrink">
            {this.renderRootImage(item)}
          </div>
          <div className="cell s-auto s-middle">
            <div className="div w5 fs11 pbottom2">
              {this.getCategoryName(item.category)}
            </div>
            <HTML>{this.renderItemName(item)}</HTML>
          </div>
          <div className="cell s-shrink s-middle">
            {this.renderFollowButton(item)}
          </div>
          <div className="cell s-shrink s-middle">
            {this.renderDetailUrl(item.detail_url)}
          </div>
          <div className="cell s-shrink s-middle  hpadd10">
            <div className={`mdi mdi-comment lh10 pr fs26 ${item.new_comments>0?'const2':'w2'}`}>
              <div className="pa pa-tl w100 tac fs12 ptop4 w1 bold ">{item.new_comments}</div>
            </div>
          </div>
        </div>
        <Link to={`/spying/${this.categoryToCode(item.category)}/${item.id}`} className="pa pa-tl w100 h100 db"></Link>
      </div>
    )
  }
  getCurPage() {
    let ob=qs.parse(this.props.router.location.search,{ ignoreQueryPrefix:true });
    return parseInt(ob.page?ob.page:1);
  }
  renderElements() {
    if(!this.props.spyingStore.list.inited) {
      return (
        <Loading />
      )
    }
    if(!this.props.spyingStore.list.data || !this.props.spyingStore.list.data.items || !this.props.spyingStore.list.data.items.length) {
      return (
        <div className="padd20 tac rad4 solid1 bo-w2 tac bg-w1">
          <div className="mdi mdi-eye w4 lh10" style={{fontSize:72}}></div>
          <div className="ptop20 fs24 font1">
            Ничего не найдено
          </div>
        </div>
      )
    }

    if(this.props.match.params.id) {
      const findRoot=this.props.spyingStore.list.data.items.filter((item)=>{
        if(item.category == this.props.category_id && item.id == this.props.match.params.id) {
          return true;
        }
        return false;
      });
      if(findRoot) {
        return (
          <>
            <LastCommentsWithStore
              standalone={this.props.standalone}
              afterCommentPost={()=>{
                this.props.spyingStore.loadCounters();
                this.reloadElements();
                // this.props.spyingStore.loadComments({ category_id: this.props.category_id });
              }}
              afterCommentRead={()=>{
                this.props.spyingStore.loadCounters();
                this.reloadElements();
                // this.props.spyingStore.loadComments({ category_id: this.props.category_id });
              }}
              renderRootElement={()=>{ return this.renderRootElement(findRoot[0]); }}
              disable_wrapper={true}
              type="spy"
              category_id={this.props.category_id}
              element_id={this.props.match.params.id} />
          </>
        )
      } else {
        return (
          <div>:(</div>
        )
      }
    }

    const items=this.props.spyingStore.list.data.items.map((item, index)=>{
      return (
        <div className="pbottom10" key={index}>
          {this.renderRootElement(item)}
        </div>
      );
    });
    return (
      <div>
        {items}
        <Paginator count={this.props.spyingStore.list.data.pages.rows} page={this.getCurPage()} rows_per_page={50} changer={(page)=>{ historyVars.appendVars({ page:page }); }} />
      </div>
    )
  }
  render() {
    if(this.props.commentsStore.standalone) {
      return (
        <div className="up12 margin">
          <div className="cell s-auto">
            <h1>{this.props.translateStore.t.lk.spying_title}</h1>
          </div>
          <div className="cell s-12">
            {this.props.disable_type_switch?null:(
              <div className="pbottom20">
                <NavLink className="fs14 padd5 mright10 dib" activeClassName="bg-pc1" activeStyle={{color:'#ffffff'}} to="/spying/all/">{this.props.translateStore.t.lk.type_all}</NavLink>
                <NavLink className="fs14 padd5 mright10 dib" activeClassName="bg-pc1" activeStyle={{color:'#ffffff'}} to="/spying/blog/">{this.props.translateStore.t.lk.type_blog}</NavLink>
                <NavLink className="fs14 padd5 mright10 dib" activeClassName="bg-pc1" activeStyle={{color:'#ffffff'}} to="/spying/figurines/">{this.props.translateStore.t.lk.type_figure}</NavLink>
                <NavLink className="fs14 padd5 mright10 dib" activeClassName="bg-pc1" activeStyle={{color:'#ffffff'}} to="/spying/anime/">{this.props.translateStore.t.lk.type_anime}</NavLink>
                <NavLink className="fs14 padd5 mright10 dib" activeClassName="bg-pc1" activeStyle={{color:'#ffffff'}} to="/spying/characters/">{this.props.translateStore.t.lk.type_character}</NavLink>
                <NavLink className="fs14 padd5 mright10 dib" activeClassName="bg-pc1" activeStyle={{color:'#ffffff'}} to="/spying/news/">{this.props.translateStore.t.lk.type_news}</NavLink>
              </div>
            )}
          </div>
          <div className="cell s-12">
            {this.renderElements()}
          </div>
        </div>
      )
    } else {
      return (
        <div className="max padding">
          <div className="up12 splice">
            <div className="cell s-auto">
              <div className="up12 margin">
                <div className="cell s-auto">
                  <h1>{this.props.translateStore.t.lk.spying_title}</h1>
                </div>
              </div>

              {this.renderElements()}
            </div>
          </div>
        </div>
      )
    }
  }
}

export default withRouter(inject("commentsStore","translateStore","router","spyingStore")(observer(Spying)));